export const environment = {
  production: false,
  chatServiceUrl: 'wss://269fr4b7gij50hdipmal.monou.gg/ws/chat',
};
